<script lang="ts">
  import BlogCard from '$lib/blog/BlogCard.svelte'
  import { t } from 'svelte-i18n-lingui';
  import type { BlogPost } from "$lib/js/strapi/types";
	import { is_set_array } from '$lib/js/helpers'
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let title = ''
  export let link = '/blog'
  export let posts: BlogPost[] = []
  export let type: '' | 'category' = ''

	const scope = getContextScope()
</script>


<div class="container {type}">
  <div class="cat-banner">
    <div class="cat-banner__title">
      <h2>{title}</h2>

      {#if type !== 'category'}
        <a class="btn" href="/{scope}{link}">
          <span class="text">{$t`View more`}</span>
          <span class="icon icon-arr-right"></span></a>
      {/if}
    </div>

    <div class="cat-banner__posts">
      {#if is_set_array(posts)}
        {#each posts as post}
          <div class="u-card--4">
            <BlogCard info={post}/>
          </div>
        {/each}
      {/if}
    </div>
  </div>
</div>


<style lang="scss">
  .cat-banner {
    margin: 50px 0;

    &__title {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 18px;

      h2 {
        margin-right: 25px;
        font-weight: 900;

        @media (min-width: 769px) {
          font-size: 36px;
        }
      }

      a {
        font-weight: 900;
        margin-bottom: 8px;
        color: black;
        margin-right: 10px;
        padding: 5px;

        span.text {
          display: inline-block;
          transition: all linear 0.125s;
        }

        span.icon {
          display: inline-block;
          transition: all linear 0.125s;
          margin-left: 8px;
        }

        &:hover {
          color: var(--main);

          span.icon {
            transform: translateX(7px);
          }
        }
      }
    }

    &__posts {
      display: flex;
      flex-wrap: wrap;
      margin-left: -6px;
      margin-right: -6px;

      @media (min-width: 1025px) {
        margin-left: -12px;
        margin-right: -12px;
      }

      .u-card--4 {
        margin: 10px 6px 40px;
        width: calc(100% - 12px);

        @media (min-width: 420px) {
          width: calc(50% - 12px);
        }

        @media (min-width: 1025px) {
          margin: 10px 12px 40px;
          width: calc(25% - 24px);
        }
      }
    }
  }
</style>
